import React from 'react';
import { LegalBody, Body, SmallBody, palettes } from '@indigo-ag/component-module';

import { utils } from 'shared';
import { createStylesHook } from 'shared/hooks/createStylesHook';

const useStyles = createStylesHook(() => ({
  colorGray: {
    color: `${palettes.neutral[700]} !important`
  },
  mb30: {
    marginBottom: 30
  },
  mt8: {
    marginTop: '8px !important'
  },
  mt4: {
    marginTop: '4px !important'
  },
  textTransformCapitalize: {
    textTransform: 'capitalize'
  }
}));

export interface TimelineEvent {
  createdAt: Date;
  mainText: string;
  notes?: string;
  createdBy: string;
}

export interface TimelineEventsProps {
  events: TimelineEvent[];
}

export const TimelineEvents: React.FunctionComponent<TimelineEventsProps> = ({ events }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const eventsSortingDescending = events.slice().sort((a, b) => (b.createdAt > a.createdAt ? 1 : -1));

  return (
    <>
      {eventsSortingDescending.map((event, idx) => {
        return (
          <div key={`timeline-event-${idx}`} className={classes.mb30}>
            <LegalBody letMeMargin className={classes.colorGray}>
              {utils.date.formatDate(event.createdAt, 'LL, h:mma')}
            </LegalBody>
            <Body letMeMargin className={classes.mt8}>
              {utils.text.firstLetterUppercase(event.mainText || '')}
            </Body>
            {event.notes ? (
              <SmallBody letMeMargin className={classes.mt4}>
                {event.notes}
              </SmallBody>
            ) : null}
            <SmallBody letMeMargin className={`${classes.mt8} ${classes.colorGray}`}>
              {event.createdBy}
            </SmallBody>
          </div>
        );
      })}
    </>
  );
};
